import React, { useState, useEffect } from 'react';
import { RabbitLoader } from '@/components/ui/rabbit-loader';

interface AppLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * Link component that shows the RabbitLoader before navigating to the app domain.
 * This creates a seamless transition experience between marketing and app.
 */
export function AppLink({ href, children, className }: AppLinkProps) {
  const [isNavigating, setIsNavigating] = useState(false);

  // Reset loader state when user navigates back (bfcache restoration)
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        setIsNavigating(false);
      }
    };
    
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setIsNavigating(true);
    
    // 1.65s transition loader between marketing and app
    setTimeout(() => {
      window.location.href = href;
    }, 2000);
  };

  if (isNavigating) {
    return (
      <div className="fixed inset-0 z-[9999]">
        <RabbitLoader message="" />
      </div>
    );
  }

  return (
    <a href={href} onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
